const HTML_TAG_PATTERN = /<[^>]*>/g;
const MULTIPLE_SPACES_PATTERN = /\s+/g;

export const stripHtml = (html) => {
  if (!html) return "";
  return html.replace(HTML_TAG_PATTERN, " ").replace(MULTIPLE_SPACES_PATTERN, " ").trim();
};
